module.exports = __webpack_public_path__ + "img/methodology-certificate.ba821829.jpg";